import React, { useState, useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useHistory } from 'react-router-dom';

import { trackEvent } from '../../../lib/analytics';

import {
    fetchTemplatesList,
    toggleModalTemplateClone,
} from '../../../redux/main/main.actions';
import {
    selectTemplatesList,
} from '../../../redux/main/main.selectors';

import Notify from '../../../components/Notify/Notify';
import ModalProfileMenu from '../../../components/Modals/ModalProfileMenu/ModalProfileMenu';
import ModalWorkspaceMenu from '../../../components/Modals/ModalWorkspaceMenu/ModalWorkspaceMenu';

import ModalPricingPlanLimit from '../../../components/Modals/ModalPricingPlanLimit/ModalPricingPlanLimit';
import ModalPricingPlanUpgrade from '../../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';

import ModalInviteToApp from '../../../components/Modals/ModalInvitePeople/ModalInvitePeople';
import ModalFeedbackThanks from '../../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks';

import ModalTemplateClone from '../../../components/Modals/ModalTemplateClone/ModalTemplateClone';
import ModalTemplateDetails from '../../../components/Modals/ModalTemplateDetails/ModalTemplateDetails';

import Sidebar from '../_components/Sidebar/Sidebar';
import Header from '../_components/Header/Header';
import TemplateGrid from '../_components/TemplateGrid/TemplateGrid';

import '../MainApp.scss';
import './Templates.scss';

const Templates = () => {
    document.title = 'Templates - DB Design';

    useEffect(() => {
        document.title = 'Templates - DB Design';
    }, []);

    const dispatch = useDispatch();
    // const history = useHistory();

    const [selectedType, setSelectedType] = useState('all');

    const templatesList = useSelector(selectTemplatesList);
    const templates = templatesList || [];

    const handleClick = () => {
        dispatch(toggleModalTemplateClone());
    };

    const handleSelectType = (value) => {
        trackEvent(`app_templates_select_${value}`, {
            page: 'app',
            type: 'templates',
        });
        setSelectedType(value);
    };

    useEffect(() => {
        dispatch(fetchTemplatesList());
    }, [dispatch]);

    return (
        <div className="dash-container">
            <Sidebar />
            <div className='dash-main'>

                {/* common modals */}
                <Notify viewType='main' />
                <ModalProfileMenu />
                <ModalWorkspaceMenu />

                <ModalPricingPlanLimit />
                <ModalPricingPlanUpgrade />

                <ModalInviteToApp />
                <ModalFeedbackThanks />

                {/* page components */}
                <ModalTemplateClone />
                <ModalTemplateDetails />

                <Header title=''>
                    {/* <button className='dash-main-header-button prime' onClick={(e) => { handleClick(e); }}>Clone Template</button> */}
                </Header>

                <div className='dash-main-body'>

                    {/* templates */}
                    {/* <div className='dash-main-body-title' style={{ marginTop: '24px' }}>
                        Templates
                        <span>({templates?.filter((template) => selectedType === 'all' || template.db_engine === selectedType)?.length || 0})</span>
                    </div> */}

                    <div className='selection-group'>
                        <div className={`selection-item ${selectedType === 'all' ? 'selected' : ''}`} onClick={() => handleSelectType('all')}>All</div>
                        <div className={`selection-item ${selectedType === 'mysql' ? 'selected' : ''}`} onClick={() => handleSelectType('mysql')}>MySQL</div>
                        <div className={`selection-item ${selectedType === 'postgresql' ? 'selected' : ''}`} onClick={() => handleSelectType('postgresql')}>PostgreSQL</div>
                        <div className={`selection-item ${selectedType === 'sqlserver' ? 'selected' : ''}`} onClick={() => handleSelectType('sqlserver')}>SQL Server</div>
                        <div className={`selection-item ${selectedType === 'oracle' ? 'selected' : ''}`} onClick={() => handleSelectType('oracle')}>Oracle</div>
                        <div className={`selection-item ${selectedType === 'mariadb' ? 'selected' : ''}`} onClick={() => handleSelectType('mariadb')}>MariaDB</div>
                        <div className={`selection-item disabled ${selectedType === 'sqlite' ? 'selected' : ''}`} disabled>SQLite</div>
                        {/* <div className={`selection-item disabled ${selectedType === 'snowflake' ? 'selected' : ''}`}>Snowflake</div> */}

                        {/* <div className={`selection-item disabled ${selectedType === 'snowflake' ? 'selected' : ''}`}>Snowflake</div> */}
                        {/* <div className={`selection-item ${selectedType === 'db2' ? 'selected' : ''}`} onClick={() => handleSelectType('db2')}>Db2</div> */}
                    </div>

                    <div className="diagrams-group templates-group">
                        {templates
                            .filter((template) => selectedType === 'all' || template.db_engine === selectedType)
                            .map((template) => <TemplateGrid key={template.id} data={template} />)}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Templates;
